module.exports = __webpack_public_path__ + "img/portrait-031.fa293d10.jpg";